import React from 'react';
import { Image, Link } from '@vgn-medien-holding/vgn-fe-components';
import { PowerBranding as PowerBrandingType } from '@src/lib/graphql/generated';

interface PowerBrandingProps {
  branding: PowerBrandingType;
}

export const PowerBranding = ({ branding }: PowerBrandingProps) => {
  if (!branding?.power_branding_image_portrait?.url) return null;
  return (
    <Link href={branding?.power_branding_url} classProps={{ root: 'relative' }} target="__blank">
      <Image
        src={branding?.power_branding_image_portrait?.url}
        alt={branding?.power_branding_image_portrait?.description}
        copyright={branding?.power_branding_image_portrait?.copyright_text}
        imageMode="cover"
        classProps={{
          container:
            'h-[80vh] w-full min-h-[480px] brand-landscape:hidden brand-square:hidden brand-portrait-tall:aspect-[9/16] brand-portrait-tall:mt-[-10vh] brand-portrait-tall:h-auto brand-portrait-tall:mb-[-12vh] mb-[-10vh]',
        }}
        fill
        sizes="100vw"
      />
      <Image
        src={branding?.power_branding_image_landscape?.url}
        alt={branding?.power_branding_image_landscape?.description}
        copyright={branding?.power_branding_image_landscape?.copyright_text}
        imageMode="cover"
        classProps={{
          container:
            'h-[85vh] brand-landscape-wide:h-auto hidden brand-landscape:block brand-square:block brand-square:h-auto brand-square:aspect-[12/9] brand-landscape-wide:aspect-[21/9] mb-[-15vh]',
        }}
        fill
        sizes="100vw"
      />
      <div className="absolute inset-x-0 bottom-0 z-10 h-[9vh] bg-gradient-to-t from-background via-background/90 to-background/0"></div>
    </Link>
  );
};
